import { NyuLineProperties } from '../../../../shared/types'
import { isForecastDataKey } from '../../utils/helpers'

/*
Hatched bars are the bar-chart equivalent of the dotted `_forecast` lines used in
line-charts: the bars of a `_forecast` series are hatched rather than solid.
*/

const tileSize = 6
const stripeWidth = 2.2
const backgroundColor = '#ffffff'

export const hatchStrokeWidth = 1
export const fallbackHatchColor = '#000000'

// the bars of a `_forecast` series are hatched in their series colour
export const hatchColorOf = (series: NyuLineProperties) =>
    isForecastDataKey(series.key) && !series.barShapeType
        ? series.color?.toLowerCase() || fallbackHatchColor
        : undefined

const patternId = (color: string) => `hatch-${color.replace(/[^a-z0-9]/gi, '')}`

export const hatchFill = (color: string) => `url(#${patternId(color)})`

const swatchSize = 12

export function HatchSwatch({ color }: { color: string }) {
    return (
        <svg width={swatchSize} height={swatchSize} className="shrink-0">
            <HatchPatterns colors={[color]} />
            <rect
                x={hatchStrokeWidth / 2}
                y={hatchStrokeWidth / 2}
                width={swatchSize - hatchStrokeWidth}
                height={swatchSize - hatchStrokeWidth}
                fill={hatchFill(color)}
                stroke={color}
                strokeWidth={hatchStrokeWidth}
            />
        </svg>
    )
}

export function HatchPatterns({ colors }: { colors: string[] }) {
    return (
        <defs>
            {[...new Set(colors)].map((color) => (
                <pattern
                    key={color}
                    id={patternId(color)}
                    width={tileSize}
                    height={tileSize}
                    patternUnits="userSpaceOnUse"
                    patternTransform="rotate(-45)"
                >
                    <rect
                        width={tileSize}
                        height={tileSize}
                        fill={backgroundColor}
                    />
                    <rect width={stripeWidth} height={tileSize} fill={color} />
                </pattern>
            ))}
        </defs>
    )
}
